const _temp0 = require("./en-US.json");
module.exports = {
  "en-US": _temp0
}